export default () => {
  // const d = new Date().getHours();
  //return d > 20 || d < 4; //UTC
  return true
}
